/**
 * TripProgressBar — horizontal progress indicator with brand accent.
 */
import styled from "styled-components";

const ACCENT = "#e3292f";

const Track = styled.div`
  width: 100%;
  height: 8px;
  border-radius: 999px;
  background: #f1f5f9;
  overflow: hidden;
`;

const Fill = styled.div`
  height: 100%;
  border-radius: 999px;
  background: ${({ $full }) => ($full ? "#94a3b8" : ACCENT)};
  width: ${({ $value }) => `${Math.min(Math.max($value, 0), 100)}%`};
  transition: width 0.3s ease;
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
`;

const Label = styled.span`
  font-size: 12px;
  font-weight: 600;
  color: #64748b;
  min-width: 36px;
  text-align: right;
`;

const TripProgressBar = ({ value = 0, showLabel = true, full = false }) => {
  const clamped = Math.min(Math.max(Number(value) || 0, 0), 100);

  return (
    <Row>
      <Track aria-hidden="true">
        <Fill $value={clamped} $full={full} />
      </Track>
      {showLabel ? <Label>{Math.round(clamped)}%</Label> : null}
    </Row>
  );
};

export default TripProgressBar;
